<template>
    <div
        class="absolute inset-y-full mt-3 justify-start items-center gap-1 flex text-red-500"
        v-show="errorMessage"
    >
        <div class="w-4 h-6 relative">
            <i class="fa-regular fa-triangle-exclamation fa-sm pb-2"></i>
        </div>
        <div class="text-xs font-normal font-['Inter'] leading-none">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
export default {
    props: {
        errorType: String,
        errorMessage: String,
        errors: Array,
    },
    setup(props) {
        const errorMessage = computed(() => {
            if (props.errors.includes(props.errorType)) {
                return props.errorMessage;
            }
        });

        return { errorMessage };
    },
};
</script>
